import React from "react";
import {SvgIcon, SvgIconProps} from "@mui/material";

const BearButterflySvg = (props: any) => (<svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg" >
        <path d="M1.02067 1V33" stroke="#88888866" strokeOpacity="0.4" strokeLinecap="round" strokeDasharray="5 5"/>
        <path d="M1 18.0226H33" stroke="#88888866" strokeOpacity="0.4" strokeLinecap="round" strokeDasharray="5 5"/>
        <path d="M1.28941 23.5735H6.93282L7.89257 18.0226M31.9251 23.5735H14.1886L13.4208 18.0226" stroke="#A40C0C" strokeWidth="2"/>
        <path d="M13.4208 18.0226L10.9638 1.37006L7.89252 18.0226" stroke="#089981" strokeWidth="2"/>
    </svg>)


const BearButterfly: React.FC<SvgIconProps> = React.memo((props) => (
    <SvgIcon {...props}>
        {BearButterflySvg(props)}
    </SvgIcon>
));
export default BearButterfly


